import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const LogoGetList = createAsyncThunk(
  "LogoGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINE_LOGO_GETLIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);
const initialState = {
  LogoGetListData: {
    data: null,
    error: null,
  },
};

const LogoSlice = createSlice({
  name: "LOGO",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    //   setWorkFlowGetListData: (state) => {
    //     state.WorkFlowGetListData.data = null;
    //   },
    //   setGetWorkFlowByID: (state) => {
    //     state.GetWorkFlowByIDData.data = null;
    //   },
  },

  extraReducers: (builder) => {
    builder
      .addCase(LogoGetList.fulfilled, (state, action) => {
        state.LogoGetListData.data = action.payload;
      })
      .addCase(LogoGetList.rejected, (state, action) => {
        state.LogoGetListData.error = action.error.message;
      });
  },
});

// export const { setLoader } = LogoSlice.actions;
export default LogoSlice.reducer;
